export default __webpack_public_path__ + "static/media/Apprenticeship.6bd13c85.png";